import { message } from 'antd';
import axios from 'axios';
import { FormattedMessage, defineMessages } from 'react-intl';


import configs from 'configs';
import { queryURL } from 'utils';
import { getItem, setItem, removeItem } from 'utils/storage';
import { hasRole } from 'utils/misc';

import { getUserProfile, logout } from '../services/app';

const prefix = 'mgr';
const { authorizationUrl, clientId, tokenHandleUrl, logoutUrl } = configs;

const messages = defineMessages({
  menuDashboard: {
    id: 'menu.dashboard',
    defaultMessage: 'Trang chủ',
  },
  menuUserMgr: {
    id: 'menu.userMgr',
    defaultMessage: 'Quản lý người dùng',
  },
  menuSpaceMgr: {
    id: 'menu.spaceMgr',
    defaultMessage: 'Quản lý khách hàng',
  },
  menuSpaceDetail: {
    id: 'menu.spaceDetail',
    defaultMessage: 'Thông tin khách hàng',
  },
  msgPermissionDeny: {
    id: 'msg.appAccessDeny',
    defaultMessage: 'Tài khoản của bạn không có quyền truy cập trang này!',
  },
  msgTokenEmpty: {
    id: 'msg.tokenEmpty',
    defaultMessage: 'Token không hợp lệ!',
  },
});

export default {
  namespace: 'app',
  state: {
    ready: false,
    message: {}, // {type, content, timeout}
    user: {},
    permissions: {
      visit: [],
    },
    menu: [
      {
        id: '1',
        icon: 'laptop',
        name: messages.menuDashboard,
        route: '/',
      },
      {
        id: '2',
        bpid: '1',
        name: messages.menuUserMgr,
        icon: 'user',
        route: '/user',
      },
      {
        id: '3',
        bpid: '1',
        name: messages.menuSpaceMgr,
        icon: 'shopping-cart',
        route: '/company',
      },
      {
        id: '31',
        mpid: '-1',
        bpid: '3',
        name: messages.menuSpaceDetail,
        route: '/company/:id',
      },
    ],
    menuPopoverVisible: false,
    siderFold: getItem('siderFold') === 'true',
    darkTheme: getItem('darkTheme') === 'true',
    isNavbar: document.body.clientWidth < 769,
    navOpenKeys: JSON.parse(getItem('navOpenKeys')) || [],
  },
  subscriptions: {

    setup({ dispatch }) {
      const token = getItem('accessToken');
      if (location.pathname === '/logout') {
        removeItem('accessToken');
        window.location = '/';
        return;
      }
      if (location.pathname === '/auth/token') {
        const urlToken = queryURL('access_token');
        if (urlToken) {
          setItem('accessToken', urlToken);
          window.location = '/';
        } else {
          // message.error('token empty', 3);
          dispatch({ type: 'setMessage', payload: { type: 'error', content: 'msg.tokenEmpty', duration: 2 } });
        }
      } else if (!token) {
        // redirect to login
        window.location = `${authorizationUrl}?response_type=token&client_id=${clientId}&redirect_uri=${tokenHandleUrl}&scope=*`;
      } else {
        // set default header
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        // get user profile from auth server
        dispatch({ type: 'getUserProfile' });
      }
      let tid;
      window.onresize = () => {
        clearTimeout(tid);
        tid = setTimeout(() => {
          dispatch({ type: 'changeNavbar' });
        }, 300);
      };
    },

  },
  effects: {
    * getUserProfile({ payload }, { call, put }) {
      const { success, user } = yield call(getUserProfile, payload);
      let ready = false;
      if (success && user && user.memberships) {
        ready = user.memberships.some(m => m.appId === 'auth' && !m.spaceId && hasRole(m.role, ['administrator', 'manager']));
      }
      if (ready) {
        yield put({
          type: 'updateState',
          payload: { user, ready: true },
        });
      } else {
        yield put({ type: 'setMessage', payload: { type: 'error', content: 'msg.appAccessDeny', duration: 4 } });
        yield put({ type: 'logout', payload: 5000 });
      }
    },
    * logout({ payload }, { put }) {
      removeItem('accessToken');
      yield put({
        type: 'updateState',
        payload: { user: {}, ready: false },
      });
      setTimeout(() => {
        window.location = `${logoutUrl}?redirect=/`;
      }, payload || 1);
    },
    * changeNavbar({ payload }, { put, select }) {
      const { app } = yield (select(_ => _));
      const isNavbar = document.body.clientWidth < 769;
      if (isNavbar !== app.isNavbar) {
        yield put({ type: 'handleNavbar', payload: isNavbar });
      }
    },
  },
  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },

    setMessage(state, { payload }) {
      return {
        ...state,
        message: { ...payload },
      };
    },

    switchSider(state) {
      setItem('siderFold', !state.siderFold);
      return {
        ...state,
        siderFold: !state.siderFold,
      };
    },

    switchTheme(state) {
      setItem('darkTheme', !state.darkTheme);
      return {
        ...state,
        darkTheme: !state.darkTheme,
      };
    },

    switchMenuPopver(state) {
      return {
        ...state,
        menuPopoverVisible: !state.menuPopoverVisible,
      };
    },

    handleNavbar(state, { payload }) {
      return {
        ...state,
        isNavbar: payload,
      };
    },

    handleNavOpenKeys(state, { payload: navOpenKeys }) {
      return {
        ...state,
        ...navOpenKeys,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/app.js